import React from 'react';
import { HomeIcon, SearchIcon, LibraryIcon, PlusSquareIcon, FilmIcon } from 'lucide-react';
interface MobileNavigationProps {
  currentView: string;
  onNavigate: (view: string) => void;
}
export const MobileNavigation = ({
  currentView,
  onNavigate
}: MobileNavigationProps) => {
  return <div className="fixed bottom-0 left-0 right-0 z-40 bg-black border-t border-gray-800 md:hidden" data-id="element-209">
      <div className="flex justify-around py-2" data-id="element-210">
        <NavItem icon={<HomeIcon className="w-5 h-5 mx-auto" data-id="element-212" />} label="Home" isActive={currentView === 'home'} onClick={() => onNavigate('home')} data-id="element-211" />
        <NavItem icon={<SearchIcon className="w-5 h-5 mx-auto" data-id="element-214" />} label="Search" isActive={currentView === 'search'} onClick={() => onNavigate('search')} data-id="element-213" />
        <NavItem icon={<LibraryIcon className="w-5 h-5 mx-auto" data-id="element-216" />} label="Your Library" isActive={currentView === 'library' || currentView === 'libraryItem'} onClick={() => onNavigate('library')} data-id="element-215" />
        <NavItem icon={<FilmIcon className="w-5 h-5 mx-auto" data-id="element-218" />} label="Movies" isActive={currentView === 'movies'} onClick={() => onNavigate('movies')} data-id="element-217" />
        <NavItem icon={<PlusSquareIcon className="w-5 h-5 mx-auto" data-id="element-220" />} label="Create" isActive={currentView === 'createPlaylist'} onClick={() => onNavigate('createPlaylist')} data-id="element-219" />
      </div>
    </div>;
};
interface NavItemProps {
  icon: React.ReactNode;
  label: string;
  isActive: boolean;
  onClick: () => void;
}
const NavItem = ({
  icon,
  label,
  isActive,
  onClick
}: NavItemProps) => <button onClick={onClick} className="flex flex-col items-center justify-center py-1" style={{
  width: '20%'
}} data-id="element-221">
    <div className={`${isActive ? 'text-white' : 'text-gray-400'}`} data-id="element-222">{icon}</div>
    <span className={`text-xs mt-1 ${isActive ? 'text-white' : 'text-gray-400'}`} data-id="element-223">
      {label}
    </span>
  </button>;